import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/partner/products2/partners-games/filter'; // Importing Filter component
import Table from 'views/partner/products2/partners-games/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * PartnersGamesView class extends JetView to create a specific view for partner games.
 */
export default class PartnersGamesView extends JetView {
    /**
     * Configures the UI components for the PartnersGamesView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const left = {
            rows: [Filter, Table], // Layout containing Filter and Table components
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Check permissions for adding partner products
        if (!devConfig.getPermAction('partnerProducts2Games', 'Add')) {
            this.show('/top/dashboard'); // Redirect to dashboard if no permission
        } else {
            return {
                id: 'a5', // Unique identifier for the view
                type: 'clean', // Clean type for the form
                view: 'form', // Form view
                scroll: 'y', // Enable vertical scrolling
                rows: [
                    {
                        responsive: 'a5', // Responsive layout identifier
                        type: 'wide', // Wide type for the column
                        cols: [left], // Columns layout containing the left section
                    },
                ],
            };
        }
    }

    /**
     * Initializes the view. Currently empty but can be used for additional setup.
     */
    init() {}
}

// FILE DOCUMENTED
